import {
  get,
  post,
  put,
  del,
} from '@/utils/request';

const url = 'staff-salaries';

export function index(data) {
  return get({
    url,
    data,
  });
}

// 获取本月某店店员薪资列表
export function getStaffSalariesForCurrentMonth(store_id) {
  return get({
    url: `${url}/current-month`,
    data: { store_id },
  });
}

// 新增一条店员薪资
export function store(data) {
  return post({
    url,
    data,
  });
}

// 修改店员薪资
export function update(data) {
  return put({
    url,
    data,
  });
}

// 删除店员薪资
export function destroy(id) {
  return del({
    url: `${url}/${id}`,
  });
}
